import axios from 'axios'
import { decodeJwtTime } from './libs'
import { trace, traceRequestInterceptor, traceResponseErrorInterceptor, traceResponseInterceptor } from './trace'
import { i18nRequestInterceptor, $t } from './i18n'
import { appPrefetchInterceptor } from './appPrefetch'
const cleanCache = () => {
  try {
    caches.delete('api-cache')
  } catch (e) {
    console.error('Service Worker 删除缓存失败', e)
  }
}
const checkCookie =
  _ &&
  _.throttle(() => {
    trace.tag('CHECK_COOKIE')
    // 检测cookie是否存在,如果不存在跳转
    return _checkCookie()
  }, 3000)
const freshToken =
  _ &&
  _.throttle(_freshToken, 3000, {
    leading: true,
    trailing: false
  })

function _checkCookie() {
  var zt_verName =
    (window.zzzconfig && window.zzzconfig.getZatuVerName && window.zzzconfig.getZatuVerName()) || 'zaitu-ver'
  console.log('checkCookie', document.cookie.indexOf(zt_verName))
  if (document.cookie.indexOf(zt_verName) == -1) {
    trace.tag('GATEWAY_CHECK_COOKIE_http')
    if (sessionStorage.getItem('COOKIE_LOST')) {
      console.log('已经执行过跳转')
    } else {
      sessionStorage.setItem('COOKIE_LOST', 'true')
      console.error('cookie不存在.....跳转', document.cookie.indexOf(zt_verName))
      window.zzzconfig && window.zzzconfig.goGatePage(location.origin + '/home', true, 'checkCookie_js')
      return true
    }
  }
  return false
}
async function goGateRefresh(data, res) {
  trace.tag('COOKIE_FORCERELOAD', {
    data,
    token: localStorage.getItem('token'),
    url: res.config?.url || '',
    res: JSON.stringify(res) || ''
  })
  if (window.$flutter && window.$flutter.support.updateToken) {
    await window.$flutter.updateToken()
    location.href = location.origin + '/home'
    return
  }

  window.zzzconfig && window.zzzconfig.goGatePage(location.origin + '/home', true, 'http_js')
}

const unLogin =
  _ &&
  _.throttle(
    () =>
      trace.tag('UN_LOGIN', {
        wpk: {
          category: 207,
          msg: '登录失效'
        }
      }),
    3000
  )

function log(object) {
  window.$tool && window.$tool.logger && window.$tool.logger('zconfigNext-1', object)
}
export const get = function (instance, url, params, config) {
  let _configs = {}
  Object.assign(_configs, config)
  let p = {}
  Object.assign(p, params ? { params } : {}, _configs)
  return instance
    .get(url, p)
    .then((res) => {
      return Promise.resolve((res && res.data) || {})
    })
    .catch((err) => {
      console.error(err)
      return Promise.resolve({
        code: '-404',
        msg: err.message || $t('WLYC')
      })
    })
}

export const post = function (instance, url, data, config = {}) {
  return instance
    .post(url, data, config)
    .then((res) => {
      return Promise.resolve((res && res.data) || {})
    })
    .catch((err) => {
      console.error(err)
      return Promise.resolve({
        code: '-404',
        msg: err.message || $t('WLYC')
      })
    })
}

export async function _freshToken() {
  if (window.$flutter && window.$flutter.support.updateToken) {
    await window.$flutter.updateToken()
    return Promise.resolve({ code: '0' })
  }
  const token = localStorage.getItem('token')
  const refreshToken = localStorage.getItem('refreshToken')
  try {
    const res = await axios.get('/api/pp/passport/jsonp/refreshToken', {
      params: { jwt: token, refreshToken: refreshToken },
      baseURL: window.$ZConfig.getPassportUrl(),
      headers: { Authorization: 'Bearer ' + token },
      withCredentials: true
    })

    if (res && res.data && res.data.code === '0') {
      localStorage.setItem('token', res.data.data)
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler(
          'refreshAppToken',
          JSON.stringify({
            token: res.data.data
          })
        )
      }
      return Promise.resolve({ code: '0', data: res.data.data })
    } else {
      log({
        type: 'refreshToken-err1',
        data: res && res.data
      })
      exceptToken()
      return Promise.resolve({ code: '-1', msg: $t('freshtoken-shi-bai') })
    }
  } catch (err) {
    log({
      type: 'refreshToken-err2',
      data: err
    })
    exceptToken()
    return Promise.resolve({ code: '-2', err })
  }
}

function exceptToken() {
  console.error('token无效')
  log({
    type: 'http-exceptToken'
  })
  localStorage.removeItem('token')
  localStorage.removeItem('refreshToken')
  if (window.flutter_inappwebview) {
    window.$jump && window.$jump.login({})
  } else {
    location.replace(location.origin + '/login')
  }
}
function isNeedToken(pageUrl) {
  var notNeedTokenPrefix = [
    'api/pp/passport/jsonp/login2.json',
    'members/register', // 这个前缀,包括后面的了,所以可以注释掉
    'common/static/alipayFail.html',
    'api/pp/common/logout.json',
    'api/pp/passport/logoutEc',
    'api/pp/common/getMpOpenId.json',
    'notify/systemUpgrade.json',
    'api/pp/common/pay/cmbResult.json',
    'common/static/alipayFail',
    'common/static/alipaySuccess',
    'api/pp/common/platform/configAd/loginAd.json',
    'api/otapub/web/customer/add.json'
  ]
  let isNeedTokenRet = true
  notNeedTokenPrefix.forEach((item) => {
    if (pageUrl.indexOf(item) !== -1) {
      isNeedTokenRet = false
    }
  })
  return isNeedTokenRet
}
export const getHttpInstance = function () {
  if (window.$httpUtil) {
    return window.$httpUtil
  }
  //单利
  const instance = axios.create({
    baseURL: window.$ZConfig.getServerUrl(),
    withCredentials: true
    // timeout: 60000  // 超时的时间限制
  })

  /* eslint-disable no-proto */
  instance.__proto__ = axios
  /* eslint-enable */

  instance.interceptors.request.use(
    async function (config) {
      const token = localStorage.getItem('token')

      if (typeof config.headers == 'undefined') {
        config.headers = {}
      }
      let sid = sessionStorage.getItem('sid')
      if (sid) {
        config.headers['x-auth-token'] = sid
      }
      let ismock = localStorage.getItem('ismock')
      if (ismock) {
        config.headers['ismock'] = ismock
      }
      const _url = config.url.charAt(0) == '/' ? config.url.substring(1) : config.url
      // 如果不需要权限的接口,或者是login页面;直接返回
      if (config.noToken === true || !isNeedToken(_url) || _url.indexOf('isLogin.json') !== -1) {
        return Promise.resolve(config)
      } else {
        if (token) {
          if (checkCookie()) return
          config.headers['Authorization'] = 'Bearer ' + token
          // 新增cookie改造字段
          config.headers['Zt-Client'] = 'h5'
          const expTime = decodeJwtTime(token)
          if (expTime <= -1 || expTime - 300 * 1000 < new Date().getTime()) {
            if (window.$flutter && window.$flutter.support.updateToken) {
              await window.$flutter.updateToken()
              config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
              return Promise.resolve(config)
            } else {
              const freshRet = await freshToken()
              if (freshRet.code === '0') {
                config.headers['Authorization'] = 'Bearer ' + freshRet.data
              } else {
                exceptToken()
              }
              return Promise.resolve(config)
            }
          }
          return Promise.resolve(config)
        } else {
          if (window.$flutter && window.$flutter.support.updateToken) {
            await window.$flutter.updateToken()
            config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            return Promise.resolve(config)
          } else {
            cleanCache()
            unLogin()
            if (window.$flutter) {
              window.$flutter.logOut()
            } else if (window.$zhm) {
              window.$zhm.logoutCallBack()
            } else {
              window.$jump.login({})
            }
          }
        }
      }
    },
    (err) => {
      return Promise.resolve({
        data: { code: -1, msg: 'instance.interceptors.request catch', err }
      })
    }
  )
  instance.interceptors.request.use(traceRequestInterceptor)
  instance.interceptors.request.use(i18nRequestInterceptor)
  instance.interceptors.request.use(appPrefetchInterceptor)
  instance.interceptors.response.use(traceResponseInterceptor, traceResponseErrorInterceptor)
  instance.interceptors.response.use(
    async function (res) {
      var data = res.data || {}
      if (data.code == '-98' && !res.config.nojump) {
        if (!sessionStorage.getItem('H5_COOKIE_INFO')) {
          sessionStorage.setItem('H5_COOKIE_INFO', JSON.stringify({ data: data }))
          goGateRefresh(data, res)
        }
        return Promise.resolve({
          data: {
            code: '98',
            msg: $t('XYQZSXYM')
          }
        })
      } else if (data.code == '5400') {
        const freshRet = await freshToken()
        if (freshRet.code === '0') {
          // 刷新后,重新调到首页
          if (typeof window.isFreshTokened == 'undefined') {
            // 避免多次调用
            window.isFreshTokened = true
            location.replace(location.origin + '/home')
          }
          return Promise.resolve({
            data: {
              code: '600',
              msg: $t('token-wu-xiao-freshtoken')
            }
          })
        } else {
          return Promise.resolve({
            data: {
              code: '600',
              msg: $t('freshtoken-shua-xin-bao-cuo')
            }
          })
        }
      }
      //  else if (data.code == '-99') {
      //   if (window.$flutter && window.$flutter.support.updateToken) {
      //     await window.$flutter.updateToken()
      //     location.reload()
      //   } else {
      //     cleanCache()
      //     unLogin()
      //     if (window.$flutter) {
      //       window.$flutter.logOut()
      //     } else if (window.$zhm) {
      //       window.$zhm.logoutCallBack()
      //     } else {
      //       window.$jump.login({})
      //     }
      //   }
      // }
      return Promise.resolve(res)
    },
    (err) => {
      // 出错或正常响应拦截
      console.error('catch err', err)
      // 检查是否为取消请求的错误
      if (axios.isCancel(err)) {
        console.log('请求被取消:', err.message)
        return Promise.reject(err)
      }
      if (typeof err === 'string') {
        return Promise.resolve({
          data: {
            code: '500',
            msg: err
          }
        })
      }
      if (!err.response) {
        err.response = { data: {} }
      }
      console.log('异常4444', err)
      return Promise.resolve({
        data: {
          code: err.response?.status || -2,
          msg: err.response.statusText || $t('FWYC') + (err.response.status || '')
        }
      })
    }
  )

  const $http = {
    get: (...args) => {
      return get(instance, ...args)
    },
    post: (...args) => {
      return post(instance, ...args)
    },
    cancelToken: axios.CancelToken,
    instance
  }
  window.$httpUtil = $http
  return $http
}
